/**
 * Parses a "YYYY-MM-DD" date-only value into a local-midnight Date.
 *
 * Defensive: if a full ISO timestamp slips through (e.g. from a DB driver
 * that serializes DATE columns as Date objects -> "2026-07-14T00:00:00.000Z"),
 * this still works because we only ever read the first 10 characters.
 *
 * We deliberately build the Date from local y/m/d components (like
 * `new Date(y, m, d)`) rather than appending "Z" and letting the runtime
 * parse it, so the result matches the same local-time convention used by
 * calendar grid cells (`new Date(ym.y, ym.m, d)`) -- no UTC/local
 * timezone-offset day-shift.
 */
export function parseDateOnly(value: string): Date {
  const [y, m, d] = value.slice(0, 10).split("-").map(Number);
  return new Date(y ?? 1970, (m ?? 1) - 1, d ?? 1);
}
